import { render, staticRenderFns } from "./addMarkupModal.vue?vue&type=template&id=50238b6a&scoped=true&"
import script from "./addMarkupModal.vue?vue&type=script&lang=ts&"
export * from "./addMarkupModal.vue?vue&type=script&lang=ts&"
import style0 from "./addMarkupModal.vue?vue&type=style&index=0&id=50238b6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50238b6a",
  null
  
)

export default component.exports